import { render, staticRenderFns } from "./MainMenuButton.vue?vue&type=template&id=5f0395b9&scoped=true"
import script from "./MainMenuButton.vue?vue&type=script&lang=js"
export * from "./MainMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0395b9",
  null
  
)

export default component.exports